import { useEffect, useMemo, useRef, useState } from 'react';
import { CURSOS } from '../../utils';

// Substitui o <input list=.../> + <datalist> nativo. O datalist do navegador
// não dá pra estilizar (altura/scroll/visual ficam por conta do SO/browser),
// então montamos um combobox simples: input livre + painel filtrado e
// rolável. O usuário ainda pode digitar qualquer texto fora da lista.
export default function CursoComboBox({
    value,
    onChange,
    disabled = false,
    placeholder = 'Selecione ou digite o curso',
    style,
    list = CURSOS,
}) {
    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(null);
    const wrapRef = useRef(null);

    const filtrados = useMemo(() => {
        const v = (value || '').toLowerCase().trim();
        if (!v) return list;
        return list.filter((c) => c.toLowerCase().includes(v));
    }, [value, list]);

    // Fecha o painel ao clicar fora do componente.
    useEffect(() => {
        if (!open) return;
        const onClick = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onClick);
        return () => document.removeEventListener('mousedown', onClick);
    }, [open]);

    const escolher = (c) => {
        onChange(c);
        setOpen(false);
    };

    return (
        <div ref={wrapRef} style={{ position: 'relative' }}>
            <input
                type="text"
                value={value || ''}
                disabled={disabled}
                placeholder={placeholder}
                onChange={(e) => { onChange(e.target.value); setOpen(true); }}
                onFocus={() => setOpen(true)}
                style={style}
                autoComplete="off"
            />
            {open && filtrados.length > 0 && (
                <ul style={panelStyle}>
                    {filtrados.map((c) => (
                        <li
                            key={c}
                            onMouseDown={(e) => { e.preventDefault(); escolher(c); }}
                            onMouseEnter={() => setHover(c)}
                            onMouseLeave={() => setHover(null)}
                            style={{ ...itemStyle, background: hover === c ? '#F3F4F6' : 'transparent' }}
                        >
                            {c}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

const panelStyle = {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    left: 0,
    right: 0,
    margin: 0,
    padding: 4,
    listStyle: 'none',
    maxHeight: 220,
    overflowY: 'auto',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: 8,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
    zIndex: 30,
};

const itemStyle = {
    padding: '8px 10px',
    cursor: 'pointer',
    borderRadius: 6,
    fontSize: '0.92rem',
    color: '#111827',
};
